import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  canonical,
  type = 'website',
  structuredData = null
}) => {
  const location = useLocation();
  
  const defaultTitle = 'Максимум Тур - Туры во Владивостоке, Горящие туры, Путевки по всему миру';
  const defaultDescription = 'Турагентство Максимум Тур во Владивостоке предлагает горящие туры, минимальные цены на путевки по всему миру. Подбор туров онлайн, консультации экспертов.';
  const defaultImage = `${window.location.origin}/og-image.jpg`;
  const url = `${window.location.origin}${location.pathname}`;
  const canonicalUrl = canonical || url;

  useEffect(() => {
    // Set document title
    document.title = title || defaultTitle;

    // Update meta tags
    const updateMetaTag = (name, content, attribute = 'name') => {
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Primary meta tags
    updateMetaTag('title', title || defaultTitle);
    updateMetaTag('description', description || defaultDescription);
    updateMetaTag('keywords', keywords || 'туры Владивосток, горящие туры, купить тур, турагентство, путевки, отдых, путешествия');
    updateMetaTag('canonical', canonicalUrl, 'rel');

    // Open Graph tags
    updateMetaTag('og:title', title || defaultTitle, 'property');
    updateMetaTag('og:description', description || defaultDescription, 'property');
    updateMetaTag('og:image', image || defaultImage, 'property');
    updateMetaTag('og:url', url, 'property');
    updateMetaTag('og:type', type, 'property');
    updateMetaTag('og:locale', 'ru_RU', 'property');
    updateMetaTag('og:site_name', 'Максимум Тур', 'property');

    // Twitter tags
    updateMetaTag('twitter:title', title || defaultTitle);
    updateMetaTag('twitter:description', description || defaultDescription);
    updateMetaTag('twitter:image', image || defaultImage);
    updateMetaTag('twitter:card', 'summary_large_image');

    // Remove old structured data if exists
    const oldStructuredData = document.querySelectorAll('script[type="application/ld+json"]:not([data-persistent])');
    oldStructuredData.forEach(el => el.remove());

    // Add new structured data if provided
    if (structuredData) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(structuredData);
      document.head.appendChild(script);
    }

    // Cleanup function
    return () => {
      // Optional: cleanup logic if needed
    };
  }, [title, description, keywords, image, canonicalUrl, type, structuredData, defaultImage, url]);

  return null; // This component doesn't render anything
};

export default SEO;
